import { getReasonPhrase } from 'http-status-codes'

export interface ClaudeApiError {
  readonly statusCode: number
  readonly statusText: string
  readonly errorType: string
  readonly message: string
}

const API_ERROR_PREFIX = 'API Error:'

export function claudeApiErrorFrom(agentResponse: string): ClaudeApiError | null {
  try {
    const regex = new RegExp(String.raw`${API_ERROR_PREFIX}\s*(\d+)\s*({.+})`)
    const match = regex.exec(agentResponse)
    if (!match?.[1] || !match[2]) return null

    const statusCode = Number.parseInt(match[1], 10)
    const jsonStr = match[2]

    const errorData = JSON.parse(jsonStr) as { error?: { type?: unknown; message?: unknown } }

    const errorType = errorData?.error?.type ?? 'unknown'
    const message = errorData?.error?.message ?? 'No error message available'

    return {
      statusCode,
      statusText: getReasonPhrase(statusCode),
      errorType: typeof errorType === 'string' ? errorType : 'unknown',
      message: typeof message === 'string' ? message : 'No error message available',
    }
  } catch {
    return null
  }
}

export function isClaudeApiError(agentResponse: string | null): boolean {
  if (!agentResponse) return false
  return agentResponse.trim().startsWith(API_ERROR_PREFIX)
}
